import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UserState } from './user.reducer';

// ALL USER STATE
export const userState = createFeatureSelector<UserState>('user');

export const selectUserState = createSelector(userState, (state: UserState) => state);
export const selectUserLoading = createSelector(userState, (state: UserState) => state.loading);
export const selectUserCustomers = createSelector(userState, (state: UserState) => state.customers);
export const selectUserProfile = createSelector(userState, (state: UserState) => state.profile);
export const selectUserIsAdmin = createSelector(userState, (state: UserState) => state.isAdmin);
